/**
 * English for the campaign card (card У3): the header and «⋯», the eight
 * tabs' new words, the click drawer and the new-campaign readiness. Spread
 * into `en`, so the keys are part of `TKey` and `ru.card.ts` must cover each.
 */
export const enCard = {
  "card.meta.domain": "domain",
  "card.menu.pause": "Pause",
  "card.menu.copyLink": "Copy the link",
  "card.menu.report": "Open in Reports",
  "card.toast.linkCopied": "Link copied",
  "card.archive.title": "Archive the campaign?",
  "card.archive.stops": "The link stops working",
  "card.archive.stops.body": "People from the {source} ads will no longer reach the campaign. The ads keep spending in the ad account — stop them there.",
  "card.archive.today": "Today",
  "card.archive.today.value": "{clicks} clicks, {leads} leads, spend {cost}",
  "card.archive.hold": "{n} leads — their postbacks are still accepted",
  "card.archive.stats": "Statistics",
  "card.archive.stats.value": "stays in the reports; the campaign can be brought back from the archive",
  "card.archive.cancel": "Cancel",
  "card.archive.confirm": "Archive",

  "card.kpi.aria": "The campaign's numbers for the period",
  "card.kpi.botsCut": "bots {pct} cut",
  "card.kpi.inTransit": "≈ {sum} on the way",
  "card.kpi.waitFirst": "waiting for the first",
  "card.kpi.costFromSource": "from the source",

  "card.path.bots.share": "{pct} — crawlers, data centres",
  "card.path.shows.note": "{pct} reached the page",
  "card.path.cta.share": "LP CTR {pct}",
  "card.path.lead.share": "CR {cr} of people",
  "card.path.approve.share": "{pct} of decided",

  "card.outcome.aside": "{n} leads in the period",
  "card.outcome.approved": "Approves",
  "card.outcome.approved.why": "counted, the money came",
  "card.outcome.hold": "Hold",
  "card.outcome.hold.why": "waiting for the partner",
  "card.outcome.rejected": "Rejects",
  "card.outcome.rejected.why": "no answer, refusal, duplicate",
  "card.outcome.trash": "Trash",
  "card.outcome.trash.why": "fake number, wrong country",
  "card.outcome.age.fresh": "up to a day",
  "card.outcome.age.mid": "1–3 days",
  "card.outcome.age.old": "over 3 days",

  "card.insight.aside.compare": "for the period, against the previous {days} days",
  "card.insight.openReport": "Open the report",
  "card.insight.show": "Show",

  "card.empty.title": "Waiting for the first click",
  "card.empty.body": "The link is ready. As soon as a person taps the ad, clicks, the path and the money show up here — it updates by itself, no need to reload.",
  "card.empty.cost": "Spend from {source} comes in once the ads start spending",
  "card.empty.test": "Test click",
  "card.ready.title": "Readiness",
  "card.ready.count": "{done} of {total}",
  "card.ready.done": "done",
  "card.ready.todo": "to do",
  "card.ready.created": "Campaign created",
  "card.ready.domain": "Domain {fqdn} answers",
  "card.ready.domain.none": "The campaign has no domain",
  "card.ready.domain.ok": "HTTPS, served by the edge",
  "card.ready.domain.wait": "not served yet — the binding is being checked",
  "card.ready.postback": "The partner knows the postback",
  "card.ready.postback.none": "the campaign has no partner network",
  "card.ready.postback.seen": "{network}: a postback came {ago} ago",
  "card.ready.postback.wait": "{network}: paste the address into its account and send a test",
  "card.ready.test": "Test click",
  "card.ready.test.why": "checks the rules and the lander the way a person would see them",
  "card.ready.test.done": "arrived {ago} ago",
  "card.ready.test.go": "Make a test click",
  "card.ready.ads": "The link is in the {source} ads",
  "card.ready.ads.why": "paste it into the ad's «Website URL» — the first click shows up here within seconds",
  "card.ready.ads.copy": "Copy the link",
  "card.ready.hint": "The card switches to numbers by itself on the first visit.",

  "card.filter.add": "Filter",
  "card.filter.facets": "Filters",
  "card.filter.search": "Search",
  "card.filter.apply": "Apply",
  "card.filter.reset": "Reset",
  "card.filter.none": "Nothing found",
  "card.filter.back": "Back",
  "card.filter.active": "Applied filters",
  "card.filter.remove": "Remove the filter «{facet}»",
  "card.filter.edit": "Change the filter «{facet}»",

  "card.conv.leadAt": "Lead time",
  "card.conv.payout": "Payout",
  "card.conv.usd": "In USD",
  "card.conv.txidNet": "Network ID",
  "card.conv.city": "City",
  "card.conv.click": "Click",
  "card.conv.waits": "waits {n}",
  "card.conv.caption": "Time in {tz} · the status is updated by the partner's postback",
  "card.conv.total": "Total, {n} {leads}",
  "card.conv.empty": "No conversions in the period",

  "card.clicks.segments": "Which visits",
  "card.clicks.seg.all": "All",
  "card.clicks.seg.people": "People",
  "card.clicks.seg.bots": "Bots",
  "card.clicks.seg.leads": "With a lead",
  "card.clicks.device": "Device",
  "card.clicks.went": "Went to",
  "card.clicks.result": "Result",
  "card.clicks.live": "live · newest first",
  "card.clicks.newest": "newest first",

  "card.flow.lead": "A visitor goes through the rules top to bottom; the first that matches decides. The rest go by shares.",
  "card.flow.handBuilt": "The campaign runs on a hand-built scheme; an admin changes it.",
  "card.flow.rules": "Flow rules",
  "card.flow.rules.aside": "checked top to bottom · visits in the period",
  "card.flow.rest": "The rest —",
  "card.flow.rest.shares": "by the shares below",
  "card.flow.toOffer": "Offer",
  "card.flow.toPage": "Page",
  "card.flow.toUrl": "Link",
  "card.flow.exits": "Exits from the page",
  "card.flow.exits.aside": "branches · shows",
  "card.flow.exits.note": "They fire on the lander when the person did not tap the button. Without a branch the person just leaves.",
  "card.flow.unset": "not set",
  "card.flow.nextStep": "Second step",
  "card.flow.offerDirect": "offer {name} directly",
  "card.flow.offer": "Offer",
  "card.flow.offers.count": "offers: {n}",
  "card.flow.landers": "Landers",
  "card.flow.landers.count": "landers: {n} · shares add up to 100%",
  "card.flow.where": "Where",
  "card.flow.share": "Share",
  "card.flow.people": "People",
  "card.flow.ctas": "buttons: {n}",
  "card.flow.thanks": "Thank-you page",
  "card.flow.thanks.default": "the workspace default",

  "card.links.for": "Link for {source}",
  "card.links.domainOk": "Domain answers",
  "card.links.domainWait": "Domain not served yet",
  "card.links.test": "Test click",
  "card.links.test.hint": "opens the link with your test mark and shows where it went",
  "card.links.mark": "Mark",
  "card.links.fills": "What {source} puts in",
  "card.links.macro": "Macro",
  "card.links.adId": "· the ad, for spend",
  "card.links.postbackFor": "Postback for {network}",
  "card.links.postback.aside": "paste into the partner's account",
  "card.links.lastReal": "the last real one — {ago} ago",
  "card.links.word": "Partner's status",
  "card.links.ours": "Ours",
  "card.links.inSource": "In {source}",
  "card.links.toSource": "To {source}",
  "card.links.capi.road": "The tracker sends nothing to the source itself: the partner's ruling goes the Keitaro road to Conversions API.",
  "card.links.journal": "Whole journal",

  "card.settings.oneForm.full": "The campaign changes in one place — the editor. Here is only how it is set now.",
  "card.settings.openEditor": "Open the editor",
  "card.settings.source": "Source",
  "card.settings.domain": "Domain and address",
  "card.settings.key": "Key",
  "card.settings.key.without": "without it — the rule's page",
  "card.settings.cost": "Spend",
  "card.settings.cost.how": "How it is counted",
  "card.settings.cost.from": "From",
  "card.settings.cost.auto": "{source}, by ads",
  "card.settings.tech": "Technical",
  "card.settings.id": "Campaign ID",
  "card.settings.created": "Created",
  "card.settings.version": "Version",
  "card.settings.history": "history",

  "card.history.kinds": "Which changes",
  "card.history.kind.all": "All",
  "card.history.kind.flow": "Flow",
  "card.history.kind.links": "Links",
  "card.history.kind.status": "Status",
  "card.history.kind.cost": "Spend",
  "card.history.verb.create": "created the campaign",
  "card.history.verb.update": "changed",
  "card.history.verb.pause": "paused",
  "card.history.verb.activate": "turned on",
  "card.history.verb.archive": "archived",
  "card.history.verb.duplicate": "copied",
  "card.history.field.domain": "Domain",
  "card.history.who": "Who",
  "card.history.caption": "every change of the campaign and who made it · kept forever",
  "card.history.compare": "Compare",
  "card.history.compare.title": "What this change did",
  "card.history.compare.same": "Nothing differs",
  "card.history.rules": "rules: {n}",
  "card.history.branches": "branches: {n}",

  "click.drawer.title": "Click",
  "click.drawer.id": "click id",
  "click.drawer.conversions": "Click's conversions",
  "click.drawer.json": "Copy as JSON",
  "click.drawer.prev": "The click above",
  "click.drawer.next": "The click below",
  "click.chip.lander": "Lander {name}",
  "click.chip.cta": "Button",
  "click.chip.offer": "Offer {name}",
  "click.chip.lead": "Lead → {status}",
  "click.how.rule": "Went by rule {n}: if {cond}",
  "click.how.shares": "Went by the shares",
  "click.how.sharesAfter": "Went by the shares: rules 1–{n} did not match",
  "click.conversions.title": "This click's conversions",
  "click.conv.after": "{gap} after the click",
  "click.conv.txid": "network ID {txid}",
  "click.conv.byPostback": "by the partner's postback",
  "click.who.class": "Class",
  "click.who.score": "{n} of 100",
  "click.who.geo": "Geo",
  "click.marks": "Marks from the ad",

  "word.leads": "lead|leads",
};
